import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  safeURL; //youTube Video URL //

  constructor(private meta: Meta, private title: Title, private _sanitizer: DomSanitizer) {
    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Home page of SEO friendly app' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'Angular, CViewSurvey' }
    ]);

    this.setTitle('CViewSurvey | Go on the Mobile');
    // End SEO Meta Description


    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/EsPq62yE3AE');
    // End You Tube Video Description

  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description

  ngOnInit(): void {
  }

}
